import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import "./BlockDeals.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";
import useNiftyWebsocket from "service/websocket/NiftyWebsocketApi";

const BDL_API_URL = "https://api.moneycontrol.com/mcapi/v1/deals/list?start=0&limit=10000&orderBy=deal_date&sortBy=DESC&dealType=large&deviceType=W&apiVersion=177";
const BDL_POLL_INTERVAL_MS = 5000;
const NSE_FNO_STOCK_LIST = [
    "COCHINSHIP", "ADANIENSOL", "HUDCO", "RBLBANK", "PNBHOUSING", "NMDC", "OFSS", "ADANIGREEN",
    "CHOLAFIN", "POLICYBZR", "POWERINDIA", "VOLTAS", "VBL", "COALINDIA", "SAIL", "TATAPOWER",
    "TRENT", "CUMMINSIND", "BRITANNIA", "TATATECH", "HDFCAMC", "COLPAL", "PPLPHARMA", "AUBANK",
    "POLYCAB", "NESTLEIND", "UNITDSPR", "PREMIERENE", "HINDALCO", "SBIN", "MARICO", "BANDHANBNK",
    "GAIL", "PIIND", "NYKAA", "BAJFINANCE", "PNB", "SUZLON", "FORTIS", "BAJAJ-AUTO", "EICHERMOT",
    "SHRIRAMFIN", "DALBHARAT", "AMBUJACEM", "GRASIM", "JINDALSTEL", "KOTAKBANK", "DELHIVERY",
    "HDFCBANK", "CANBK", "OIL", "BHEL", "LICI", "JSWSTEEL", "PFC", "NTPC", "NBCC", "JUBLFOOD",
    "DIVISLAB", "AXISBANK", "M&M", "SUPREMEIND", "BANKNIFTY", "TATASTEEL", "TMPV", "ASHOKLEY",
    "CONCOR", "DIXON", "KEI", "BSE", "MAZDOCK", "NATIONALUM", "SAMMAANCAP", "MFSL", "ONGC",
    "AMBER", "PHOENIXLTD", "ADANIENT", "INDIANB", "BPCL", "PIDILITIND", "ADANIPOWER", "HINDZINC",
    "PGEL", "APOLLOHOSP", "BLUESTARCO", "INDUSTOWER", "IDEA", "INDHOTEL", "RECLTD", "TVSMOTOR",
    "LTF", "INDIGO", "TORNTPHARM", "MAXHEALTH", "ASTRAL", "PAGEIND", "PRESTIGE", "BANKBARODA",
    "FEDERALBNK", "CDSL", "CIPLA", "MARUTI", "POWERGRID", "PETRONET", "TATACONSUM", "LICHSGFIN",
    "IDFCFIRSTB", "HINDPETRO", "APLAPOLLO", "YESBANK", "CNXMIDCAP", "TATAELXSI", "BHARATFORG",
    "DLF", "LT", "NHPC", "TITAN", "DRREDDY", "PAYTM", "MCX", "IRFC", "MANKIND", "ADANIPORTS",
    "BAJAJHLDNG", "NIFTY", "RELIANCE", "MANAPPURAM", "JIOFIN", "IREDA", "MOTHERSON", "360ONE",
    "ETERNAL", "GODREJPROP", "OBEROIRLTY", "ITC", "BAJAJFINSV", "BEL", "RVNL",
    "MOTILALOFS", "CAMS", "CROMPTON", "EXIDEIND", "PATANJALI", "LAURUSLABS", "IOC", "ULTRACEMCO",
    "HEROMOTOCO", "SIEMENS", "ASIANPAINT", "INDUSINDBK", "BHARTIARTL", "AUROPHARMA", "SBICARD",
    "UNIONBANK", "GLENMARK", "BDL", "ICICIBANK", "INOXWIND", "HINDUNILVR", "UPL", "WIPRO",
    "SONACOMS", "DMART", "HAVELLS", "CGPOWER", "HDFCLIFE", "KALYANKJIL", "LODHA", "BOSCHLTD",
    "MUTHOOTFIN", "SRF", "LUPIN", "DABUR", "FORCEMOT", "UNOMINDA", "HAL", "VEDL", "ZYDUSLIFE",
    "GMRAIRPORT", "SWIGGY", "SHREECEM", "ANGELONE", "ICICIGI", "GODFRYPHLP", "TORNTPOWER",
    "NUVAMA", "VMM", "BANKINDIA", "BIOCON", "ABCAPITAL", "KFINTECH", "KAYNES", "IEX",
    "JSWENERGY", "WAAREEENER", "SBILIFE", "NAUKRI", "ABB", "KPITTECH", "HYUNDAI", "SUNPHARMA",
    "TIINDIA", "ICICIPRULI", "SOLARINDS", "TECHM", "MPHASIS", "GODREJCP", "TCS", "NAM-INDIA",
    "ALKEM", "LTM", "COFORGE", "HCLTECH", "PERSISTENT", "INFY"
];
const NSE_FNO_STOCK_SET = new Set(NSE_FNO_STOCK_LIST.map((symbol) => symbol.toUpperCase()));

export default function BlockDeals() {

    // WebSocket connection
    const { blockDealsLargeStockData, blockDealsTopStockData, stockSectorAnalysisData } = useStockApiWebsocket(environment.stockApiDayRangeDataWSUrl);
    const { nseWebsiteOIResponseData } = useNiftyWebsocket(environment.niftyWebsocketUrl);
    const [blockDealsLargeStockDataList, setblockDealsLargeStockDataList] = useState([]);
    const [blockDealsTopStockDataList, setblockDealsTopStockDataList] = useState([]);
    const [bdlDealsDataList, setBdlDealsDataList] = useState([]);
    const [bdlLoading, setBdlLoading] = useState(false);
    const [bdlError, setBdlError] = useState("");
    const [activeTab, setActiveTab] = useState("BLOCK_DEALS_LARGE_STOCK");
    const [nseWebsiteOIResposneDataList, setNseWebsiteOIResposneDataList] = useState(null);
    const [stockSectorAnalysis, setStockSectorAnalysis] = useState([]);
    /* ============================================== */
    const oiRecordTimeMap = useRef(new Map());
    const bdlPollInFlightRef = useRef(false);

    useEffect(() => {
        if (Array.isArray(blockDealsLargeStockData) && blockDealsLargeStockData.length > 0) {
            setblockDealsLargeStockDataList(blockDealsLargeStockData);
           console.log('blockDealsLargeStockData => ', blockDealsLargeStockData);
        }
    }, [blockDealsLargeStockData]);

    useEffect(() => {
        if (Array.isArray(blockDealsTopStockData) && blockDealsTopStockData.length > 0) {
            setblockDealsTopStockDataList(blockDealsTopStockData);
           // console.log('blockDealsTopStockData => ', blockDealsTopStockData);
        }
    }, [blockDealsTopStockData]);

    useEffect(() => {
        if (nseWebsiteOIResponseData) {
            const mappedData = buildNseWebsiteOIResponseOIDataMap(nseWebsiteOIResponseData);
            setNseWebsiteOIResposneDataList(mappedData);
            // console.log('nseWebsiteOIResposneDataList => ', mappedData);
        }
    }, [nseWebsiteOIResponseData]);

    useEffect(() => {
        if (Array.isArray(stockSectorAnalysisData) && stockSectorAnalysisData.length > 0) {
            setStockSectorAnalysis(stockSectorAnalysisData);
            //  getTopAndBottomCHP(stockSectorAnalysisData);
            // console.log("Stock Sector Analysis Data:", stockSectorAnalysisData);
        }
    }, [stockSectorAnalysisData]);

    useEffect(() => {
        let isMounted = true;

        const fetchBdlDealsData = async () => {
            if (bdlPollInFlightRef.current) {
                return;
            }

            bdlPollInFlightRef.current = true;
            if (isMounted) {
                setBdlLoading(true);
            }

            try {
                const response = await axios.get(BDL_API_URL);
                const latestBdlDeals =
                    Array.isArray(response && response.data && response.data.data)
                        ? response.data.data
                        : [];

                const filteredBdlDeals = latestBdlDeals.filter((deal) => {
                    const exchange =
                        deal && deal.exchange ? String(deal.exchange).toUpperCase() : "";
                    const dealValue = Number(deal && deal.dealValue);
                    const tradedPrice = Number(deal && deal.tradedPrice);
                    const symbol =
                        deal && typeof deal.sc_nseid === "string"
                            ? deal.sc_nseid.trim().toUpperCase()
                            : "";

                    return (
                        exchange === "NSE" &&
                        dealValue >= 3 &&
                        tradedPrice >= 500 &&
                        symbol !== "" &&
                        NSE_FNO_STOCK_SET.has(symbol)
                    );
                });

                if (!isMounted) {
                    return;
                }
                console.log("Filtered BDL Deals:", filteredBdlDeals);
                setBdlDealsDataList(filteredBdlDeals);
                setBdlError("");
            } catch (error) {
                console.error("Error fetching BDL data:", error);

                if (!isMounted) {
                    return;
                }

                setBdlError("Unable to load BDL data.");
            } finally {
                bdlPollInFlightRef.current = false;

                if (isMounted) {
                    setBdlLoading(false);
                }
            }
        };

        fetchBdlDealsData();
        const pollIntervalId = window.setInterval(fetchBdlDealsData, BDL_POLL_INTERVAL_MS);

        return () => {
            isMounted = false;
            bdlPollInFlightRef.current = false;
            window.clearInterval(pollIntervalId);
        };
    }, []);

    const buildNseWebsiteOIResponseOIDataMap = (response) => {

        const processList = (list = []) => {
            return list.map((record) => {

                const key = `${record.symbol}_${record.instrument}_${record.expiryDate}_${record.optionType}`;

                // ✅ Only set time for new record
                if (!oiRecordTimeMap.current.has(key)) {
                    oiRecordTimeMap.current.set(key, new Date().toLocaleTimeString());
                }

                return {
                    ...record,
                    time: oiRecordTimeMap.current.get(key)
                };
            });
        };

        const getOIData = (key) => {
            const responseData = response?.data || [];

            for (let item of responseData) {
                const source = item?.categories || item;
                const value = source?.[key];
                if (value) {
                    return processList(value); // ✅ Apply timestamp here
                }
            }
            return [];
        };

        return {
            "Rise-in-OI-Rise": getOIData("Rise-in-OI-Rise"),
            "Rise-in-OI-Slide": getOIData("Rise-in-OI-Slide"),
            "Slide-in-OI-Rise": getOIData("Slide-in-OI-Rise"),
            "Slide-in-OI-Slide": getOIData("Slide-in-OI-Slide")
        };
    };
    const getTopAndBottomCHP = (data) => {
        if (!Array.isArray(data) || data.length < 2) return {};

        // Sort by CHP ascending
        const sorted = [...data].sort((a, b) => a.chp - b.chp);

        return {
            firstLowest: sorted[0],
            secondLowest: sorted[1],
            thirdLowest: sorted[2],

            firstHighest: sorted[sorted.length - 1],
            secondHighest: sorted[sorted.length - 2],
            thirdHighest: sorted[sorted.length - 3],
        };
    };

    const formatDealTime = (value) => {
        if (!value) return "--";

        const formattedValue = String(value).padStart(4, "0");
        return `${formattedValue.slice(0, 2)}:${formattedValue.slice(2)}`;
    };

    // Header Data
    const headerSource = 
    //activeTab === "BDL" ? (bdlDealsDataList?.[0] ?? {}): 
       
        (blockDealsLargeStockDataList?.[0] ?? {});
    const headerData = [
        {
            label1: "1st HS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.firstHighest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.firstHighest?.chp ?? "--",
        },
        {
            label1: "2nd HS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.secondHighest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.secondHighest?.chp ?? "--",
        },
        {
            label1: "1st LS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.firstLowest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.firstLowest?.chp ?? "--",
        },
        {
            label1: "2nd LS",
            value1: getTopAndBottomCHP(stockSectorAnalysis)?.secondLowest?.symbol?.split(":")[1]?.split("-")[0] ?? "--",
            label2: "CHP",
            value2: getTopAndBottomCHP(stockSectorAnalysis)?.secondLowest?.chp ?? "--",
        },
        {
            label1: "Date",
            value1: 
            //activeTab === "BDL" ? (headerSource?.deal_date ?? "--") : 
            (headerSource?.localDate ?? "--"),
            label2: "Time",
            value2: //activeTab === "BDL" ? formatDealTime(headerSource?.deal_time) : 
            (headerSource?.localTime ?? "--"),
        },
    ];

    const formatValue = (value) => {
        if (value == null || isNaN(value)) return "--";

        const num = Number(value);
        const absNum = Math.abs(num);
        const sign = num < 0 ? "-" : "";


        // 🔥 Whole number (no decimal)
        if (Number.isInteger(num)) {
            return `${sign}${absNum.toLocaleString("en-IN")}`;
        }

        // 🔥 Default (Indian format with 2 decimal)
        return `${sign}${absNum.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

    const getChpColor = (value) => {
        const num = Number(value);
        if (isNaN(num)) return "white";
        if (num > 0) return "#0dc80d";   // green
        if (num < 0) return "rgb(228 67 67)";   // red
        return "white";
    };
    const leftData = headerData.filter(item => item.label1 !== "Date");
    const rightData = headerData.find(item => item.label1 === "Date");

    const getValueClass = (value) => (value < 0 ? "span-color-red" : "span-color-green");
    return (
        <div className="block-deals-page">

            {/* ================= HEADER ================= */}
            <header className="header">
                <nav className="nav-container">
                    <div className="header-flex">

                        {/* ===== LEFT SIDE ===== */}
                        <div className="left-nav">

                            <div className="logo-container">
                                <img
                                    src="/assets/images/noptionwave-logo-1.png"
                                    className="header-logo"
                                    alt="logo"
                                />
                            </div>

                            {leftData.map((item, idx) => {
                                const color =
                                    item.label2 === "CHP"
                                        ? getChpColor(item.value2)
                                        : "white";

                                return (
                                    <div className="header-item" key={idx}>
                                        <span className="header-line" style={{ color }}>
                                            {item.label1} : {item.value1}
                                        </span>

                                        <span className="header-line" style={{ color }}>
                                            {item.label2} : {item.value2}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>

                        {/* ===== RIGHT SIDE (DATE & TIME) ===== */}
                        {rightData && (
                            <div className="right-nav">
                                <span className="header-line" style={{ color: "white" }}>
                                    {rightData.label1} : {rightData.value1}
                                </span>
                                <span className="header-line" style={{ color: "white" }}>
                                    {rightData.label2} : {rightData.value2}
                                </span>
                            </div>
                        )}

                    </div>
                </nav>
            </header>

            {/* ===== TABS ===== */}
            <div className="tab-container">
                <div className="tab">

                    <button className={`tablinks sub-header-font ${activeTab === "BLOCK_DEALS_LARGE_STOCK" ? "active" : ""}`}
                        onClick={() => setActiveTab("BLOCK_DEALS_LARGE_STOCK")}  >
                        BLOCK DEALS LS
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "BDL" ? "active" : ""}`}
                        onClick={() => setActiveTab("BDL")}  >
                        BDL
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "BLOCK_DEALS_TOP_STOCK" ? "active" : ""}`}
                        onClick={() => setActiveTab("BLOCK_DEALS_TOP_STOCK")}  >
                        BLOCK DEALS TS
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "BUYING" ? "active" : ""}`}
                        onClick={() => setActiveTab("BUYING")} >
                        BUYING
                    </button>

                    <button className={`tablinks sub-header-font ${activeTab === "SELLING" ? "active" : ""}`}
                        onClick={() => setActiveTab("SELLING")} >
                        SELLING
                    </button>
                    <button className={`tablinks sub-header-font ${activeTab === "WEAK_SELLING" ? "active" : ""}`}
                        onClick={() => setActiveTab("WEAK_SELLING")} >
                        WEAK SELLING
                    </button>
                    <button className={`tablinks sub-header-font ${activeTab === "WEAK_BUYING" ? "active" : ""}`}
                        onClick={() => setActiveTab("WEAK_BUYING")} >
                        WEAK BUYING
                    </button>
                </div>
            </div>

            {/* ================= GRID ================= */}

            {activeTab === "BDL" && (
                <div className="table-container">

                    <table className="responsive-table text-center sticky-header">
                        <thead>
                            <tr>
                                <th>DEAL DATE & TIME</th>
                                <th>SYMBOL</th>
                                <th>TRADED PRICE</th>
                                <th>DEAL VALUE & QUANTITY</th>
                                <th>SECTOR</th>
                                <th>VOLUME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bdlDealsDataList?.length > 0 ? (
                                bdlDealsDataList.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="deal-cell">

                                            <div className="deal-row">
                                                <span>{row.deal_date ?? "--"}</span>
                                                <span className="span-color-price">
                                                    {formatDealTime(row.deal_time)}
                                                </span>
                                            </div>
                                        </td>
                                        <td> <span className="span-color-price">{row.sc_nseid ?? "--"}</span></td>
                                        <td><span className="span-color-price">Price: {formatValue(row.tradedPrice) ?? "--"}</span></td>
                                        <td className="deal-cell">
                                            <div className="deal-row">

                                                <span>Rs.</span>
                                                <span className="span-color">{row.dealValue ?? "--"} </span>

                                                <span>Crores</span>
                                                <span>NSE Block Trade For</span>
                                                <span className="span-color">{formatValue(row.quantity) ?? "--"}</span>
                                                <span>Shares</span>


                                            </div>
                                        </td>
                                        <td>{row.stock_sector ?? "--"}</td>
                                        <td><span>{formatValue(row.volume) ?? "--"}</span></td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="15">{bdlError || (bdlLoading ? "Loading BDL data..." : "No BDL data available.")}</td>
                                </tr>
                            )}
                        </tbody>

                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== BLOCK DEALS ===== */}
            {activeTab === "BLOCK_DEALS_LARGE_STOCK" && (
                <div className="table-container">

                    <table className="responsive-table text-center sticky-header">
                        <thead>
                            <tr>
                                <th>DEAL DATE & TIME</th>
                                <th>SYMBOL</th>
                                <th>TRADED PRICE</th>
                                <th>DEAL VALUE & QUANTITY</th>
                                <th>SECTOR</th>
                                <th>VOLUME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {blockDealsLargeStockDataList?.length > 0 ? (
                                blockDealsLargeStockDataList.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="deal-cell">

                                            <div className="deal-row">
                                                <span>{row.deal_date ?? "--"}</span>
                                                <span className="span-color-price">
                                                    {formatDealTime(row.deal_time)}
                                                </span>
                                            </div>
                                        </td>
                                        <td> <span className="span-color-price">{row.sc_nseid ?? "--"}</span></td>
                                        <td><span className="span-color-price">Price: {formatValue(row.tradedPrice) ?? "--"}</span></td>
                                        <td className="deal-cell">
                                            <div className="deal-row">

                                                <span>Rs.</span>
                                                <span className="span-color">{row.dealValue ?? "--"} </span>

                                                <span>Crores</span>
                                                <span>NSE Block Trade For</span>
                                                <span className="span-color">{formatValue(row.quantity) ?? "--"}</span>
                                                <span>Shares</span>


                                            </div>
                                        </td>
                                        <td>{row.stock_sector ?? "--"}</td>
                                        <td><span>{formatValue(row.volume) ?? "--"}</span></td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="15">Waiting for live data...</td>
                                </tr>
                            )}
                        </tbody>

                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {activeTab === "BLOCK_DEALS_TOP_STOCK" && (
                <div className="table-container">

                    <table className="responsive-table text-center sticky-header">
                        <thead>
                            <tr>
                                <th>DEAL DATE</th>
                                <th>SYMBOL</th>
                                <th>TRADED PRICE</th>
                                <th>DEAL VALUE & QUANTITY</th>
                                <th>SECTOR</th>

                            </tr>
                        </thead>
                        <tbody>
                            {blockDealsTopStockDataList?.length > 0 ? (
                                blockDealsTopStockDataList.map((row, idx) => (
                                    <tr key={idx}>
                                        <td className="deal-cell">

                                            <div className="deal-row">
                                                <span>{row.deal_date ?? "--"}</span>

                                            </div>
                                        </td>
                                        <td> <span className="span-color-price">{row.sc_nseid ?? "--"}</span></td>
                                        <td><span className="span-color-price">Price: {formatValue(row.tradedPrice) ?? "--"}</span></td>
                                        <td className="deal-cell">
                                            <div className="deal-row">

                                                <span>Rs.</span>
                                                <span className="span-color">{row.dealValue ?? "--"} </span>

                                                <span>Crores</span>
                                                <span>NSE Block Trade For</span>
                                                <span className="span-color">{formatValue(row.quantity) ?? "--"}</span>
                                                <span>Shares</span>


                                            </div>
                                        </td>
                                        <td>{row.stock_sector ?? "--"}</td>


                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="15">Waiting for live data...</td>
                                </tr>
                            )}
                        </tbody>

                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== BUYING ===== */}
            {activeTab === "BUYING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th> */}
                                {/* <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Rise-in-OI-Rise"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td> */}
                                        {/* <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== SELLING ===== */}
            {activeTab === "SELLING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th>
                                <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Rise-in-OI-Slide"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td>
                                        <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== WEAK SELLING ===== */}
            {activeTab === "WEAK_SELLING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th>
                                <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Slide-in-OI-Slide"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td>
                                        <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

            {/* ===== WEAK BUYING ===== */}
            {activeTab === "WEAK_BUYING" && (
                <div className="table-container">

                    <table className="responsive-table responsive-table-ce table-bordered text-center sticky-header">
                        <thead>
                            <tr>
                                <th>SYMBOL</th>
                                <th>INSTRUMENT</th>
                                <th>EXPIRY</th>
                                {/* <th>STRIKE PRICE</th>
                                <th>OPTION TYPE</th> */}
                                <th>LTP</th>
                                <th>OICHG</th>
                                <th>TIME</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nseWebsiteOIResposneDataList?.["Slide-in-OI-Rise"]
                                ?.filter(row => row.instrument?.toLowerCase() === "stock futures")
                                .map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.symbol ?? "--"}</td>
                                        <td> {row.instrument ?? "--"} </td>
                                        <td> {row.expiryDate ?? "--"} </td>
                                        {/* <td className="hedge-strike-price-color">{row.strikePrice}</td>
                                        <td >
                                            <span className={
                                                row.optionType?.toLowerCase() === "call" ? "call-row" : row.optionType?.toLowerCase() === "put" ? "put-row" : ""}>
                                                {row.optionType?.toUpperCase() ?? "--"}
                                            </span>
                                        </td> */}
                                        <td> {formatValue(row.ltp) ?? "--"} </td>
                                        <td >
                                            <span className={getValueClass(row.changeInOI)}>
                                                {formatValue(row.changeInOI) ?? "--"}
                                            </span>
                                        </td>
                                        <td> {row.time ?? "--"} </td>
                                    </tr>
                                ))}
                        </tbody>
                        <tfoot className="fixed-footer">
                            <tr className="footer-left">
                                <td colSpan="15">noptionwave © 2026</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}

        </div>
    );
}
